import { render, staticRenderFns } from "./OwnerVsBreakdown.vue?vue&type=template&id=9a860b18&scoped=true&"
import script from "./OwnerVsBreakdown.vue?vue&type=script&lang=js&"
export * from "./OwnerVsBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./OwnerVsBreakdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OwnerVsBreakdown.vue?vue&type=style&index=1&id=9a860b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a860b18",
  null
  
)

export default component.exports